import auth from './Auth';
import guest from './Guest';

export default {
  auth,
  guest,
};
